<template>
  <div>
    <common-dialog
      ref="dialog"
      width="350px"
      show-save-button
      unit="科目"
      id-key="SubjectId"
      :data="data"
      form-label-width="55px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="科目" prop="Subject">
              <el-input size="mini" v-model="data.Subject" placeholder="请填写科目"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="序号" prop="SubjectNumber">
              <el-input-number :min="0" v-model="data.SubjectNumber"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        SubjectId: 0,
        Subject: "",
        SubjectNumber: 0,
      },
      api: require("@/api/ed/subject").default,
      isMB: this.$store.state.isMB,
      rules: {
        Subject: [{ required: true, message: "请填写科目" }],
        SubjectNumber: [{ required: true, message: "序号不能为空" },{ validator: this.$commonJs.validateRules.int }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
      this.api.getMaxNumber().then(res => {
        this.data.SubjectNumber = res.Data
      })
    },
    onEditOpened() {
    },
    onBeforeSave() {
    },
  },
};
</script>
<style lang="scss">
</style>